



















import { Component, Vue } from 'vue-property-decorator';

import Container from '@/components/layout/Container.vue';
import GamePreviewIcon from '@/components/homescapes/hs000v1/GamePreviewIcon.vue';
import GamePreviewText from '@/components/homescapes/hs000v1/GamePreviewText.vue';
import GamePreviewSlides from '@/components/homescapes/hs000v1/GamePreviewSlides.vue';

import * as SLIDES from '@/config/versions/pr/slides';

@Component({
  components: {
    Container,
    GamePreviewSlides,
    GamePreviewText,
    GamePreviewIcon,
  },
})
export default class GamePreview extends Vue {
  get slides(): Slides {
    return SLIDES as Slides;
  }

  get localeSlides() {
    const { locale } = this.$i18n;

    const { en: defaultSlides } = this.slides;

    return this.slides[locale] || defaultSlides;
  }
}
